import type { FuseConfig } from '@strata-monorepo/shared-types/src/fuse'

// type grid should be used anywhere where rates are also visible
// type banner should be used anywhere where rates are not visible or may not be visible
export const getFuseConfig = (
  fuseConfigs: FuseConfig[],
  type: 'banner' | 'grid',
): FuseConfig | undefined => {
  if (type === 'banner') {
    return fuseConfigs.find((fuseConfig) => fuseConfig.name.includes('PERMA-BANNER'))
  } else if (type === 'grid') {
    return fuseConfigs.find((fuseConfig) => fuseConfig.name.includes('PERMA-GRID'))
  }
}
